$(document).ready(function () {
    /**
     * TCR Module 
     */
    let results = {};
    let value, key;
    let objectStructure = null;
    let index = 0;
    function createObj(obj, boxes) {
        key = obj.closest('.box').find('h2').data('title');
        value = obj.text().replaceAll(" ", "_");
        if (objectStructure == null) {
            results[key] = value;
        } else if (boxes.hasClass('three')) {
            if (typeof results[key] === 'object') {
                results[key][index++] = value;
            } else {
                results[key] = {};
                results[key][index++] = value;
            }
            objectStructure = results
        } else {
            results[key] = value;
        }
        objectStructure = results;
        // console.log(objectStructure)
    
        funnelEventEmitter('surveyResults', objectStructure);
    }

    /**
     * Survey UI
     */
    if ($(window).width() < 1024) {
        $('.nextStep').addClass('hidden');
    }

    $('.answer').on('click', function () {
        const boxes = $('.boxes');

        createObj($(this), boxes);

        if ($(window).width() < 1024) {
            if (boxes.hasClass('one')) {
                boxes.removeClass('one').addClass('two');

            } else if (boxes.hasClass('two')) {
                boxes.removeClass('two').addClass('three');
            }

            $('.box.three .answers li').on('click', function () {
                $('.nextStep').removeClass('hidden').addClass('show');
            })
        }
    });

    /**
     * Queue popup with delay redirection
     */
    $('a[data-param]').click(function () {
        let path = $(this).attr('href');

        setTimeout(function () {
            window.location.href = path;
        }, 5000);
    });
});